<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">
        <!-- Bandeau dégradé + header -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 space-y-3">
                <app-header icon="bouteille" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Régularisation</h1>
                    </div>
                </app-header>

                <action-bar :back="{name:'bouteille', params: {id: bouteille.id}}" class=" !m-0 pb-6">
                </action-bar>
            </div>
        </div>

        <!-- Corps avec arrondi haut + dégradé clair -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="m-2 shadow-2xl rounded-lg overflow-hidden mb-24">
                <!-- Carte formulaire -->
                <div class="bg-white p-4">
                    <form class="space-y-4" @submit.prevent="sendForm">
                        <!-- Titre quantité actuelle -->
                        <h2 class="text-lg font-bold text-secondary mb-4">
                            QUANTITÉ ACTUELLE : {{ bouteille.poids_net }} / {{ bouteille.poids_max }} Kg
                        </h2>

                        <!-- Type de régularisation -->
                        <div>
                            <label class="label">Type de régularisation <span class="text-alert">*</span></label>
                            <div class="grid grid-cols-2 gap-3">
                                <div>
                                    <input id="type-ajout" type="radio" name="type" value="6" v-model.number="op.type" class="hidden">
                                    <label for="type-ajout"
                                        class="flex items-center justify-center gap-2 h-12 rounded-lg border-2 transition-all cursor-pointer"
                                        :class="op.type === 6 ? 'bg-secondary text-white border-secondary' : 'bg-gray-100 text-gray-600 border-gray-300 hover:border-gray-400'">
                                        <span>Ajout</span>
                                        <i v-if="op.type === 6" class="inline-block h-5 w-5 mask mask-check bg-white"></i>
                                    </label>
                                </div>
                                <div>
                                    <input id="type-retrait" type="radio" name="type" value="7" v-model.number="op.type" class="hidden">
                                    <label for="type-retrait"
                                        class="flex items-center justify-center gap-2 h-12 rounded-lg border-2 transition-all cursor-pointer"
                                        :class="op.type === 7 ? 'bg-secondary text-white border-secondary' : 'bg-gray-100 text-gray-600 border-gray-300 hover:border-gray-400'">
                                        <span>Retrait</span>
                                        <i v-if="op.type === 7" class="inline-block h-5 w-5 mask mask-check bg-white"></i>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Quantité corrigée -->
                        <div>
                            <label for="quantity" class="label">
                                Quantité corrigée <span class="text-alert">*</span>
                            </label>
                            <input type="number" step="0.001" min="0" id="quantity" v-model.number="op.quantity" class="input">
                        </div>

                        <!-- Commentaire -->
                        <div>
                            <label for="comment" class="label">Commentaire <span class="text-alert">*</span></label>
                            <textarea name="comment" id="comment" v-model="op.comment" maxlength="500"
                                class="input min-h-[100px] resize-y"></textarea>
                        </div>

                        <!-- Bouton submit -->
                        <button type="submit"
                            class="w-full bg-primary text-white font-semibold tracking-wide px-5 py-3 rounded-xl shadow hover:shadow-md active:scale-[0.99] transition">
                            Valider
                        </button>
                    </form>
                </div>
            </div>
        </main>
    </main-layout>
</template>

<script>
    import Bouteille from '../../js/models/Bouteille'
    import OperationBouteille from "../../js/models/OperationBouteille";
    import Offline from '../../js/models/Offline';

    export default {
        data() {
            return {
                op: {
                    type: null,
                    quantity: null,
                    comment: null
                },
                bouteille: {}
            }
        },

        methods: {
            sendForm() {
                if (this.op.type && this.op.quantity && this.op.comment) {
                    if (this.op.type === 6) {
                        if (this.bouteille.poids_net + this.op.quantity > this.bouteille.poids_max) {
                            swal('Quantité incohérente', `(${this.bouteille.poids_net}/${this.bouteille.poids_max} Kg)`, 'error');
                        } else {
                            this.newOperation();
                        }
                    } else if (this.op.type === 7) {
                        if (this.bouteille.poids_net - this.op.quantity < 0) {
                            swal('Quantité incohérente', `(${this.bouteille.poids_net}/${this.bouteille.poids_max} Kg)`, 'error');
                        } else {
                            this.newOperation();
                        }
                    }
                } else {
                    swal('Formulaire incomplet', "Veuillez compléter le formulaire", 'error');
                }
            },

            async newOperation() {
                let opObj = new OperationBouteille();
                const profil = JSON.parse(await localforage.getItem('profil'));

                let op = {
                    id: 'N-' + +new Date(),
                    id_fibsdd: null,
                    id_bouteille: this.bouteille.id,
                    type: this.op.type === 6 ? 'Régularisation "ajout"' : 'Régularisation "retrait"',
                    id_type: parseInt(this.op.type),
                    quantite: round(this.op.quantity, 3),
                    id_fluide: this.bouteille.fluide.id,
                    date: moment().format('YYYY-MM-DD'),
                    user: profil.first_name.charAt(0).toUpperCase() + '. ' + profil.last_name.toUpperCase(),
                    commentaire: this.op.comment,
                    createdAt: moment().format('YYYY-MM-DD HH:mm:ss')
                };

                let ops = await opObj.getList();
                ops.push(op);

                await localforage.setItem('listOperations', JSON.stringify(ops));
                await Offline.saveAction({
                    action: 'add',
                    type: 'OperationBouteille',
                    id: op.id
                });
                await Bouteille.applyOperation(op);

                this.$router.push({name: "bouteille", params: {id: this.bouteille.id}});
                return true;
            },

            fetchBottle() {
                return new Promise((resolve, reject) => {
                    let idBout = this.$route.params.id;

                    Bouteille.getBouteille(idBout).then(data => {
                            this.bouteille = data;
                            resolve(data)
                        })
                        .catch(err => reject(err))
                })
            }
        },

        mounted: function(){
            this.fetchBottle();
        },

        computed: {}
    }
</script>

<style scoped>
/* Styles spécifiques si nécessaire */
</style>



// WEBPACK FOOTER //
// BouteilleRegul.vue?010094ad